"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
async function default_1(options) {
    const currentJWT = options.getJWT();
    const oldSession = options.getSession() || {};
    if (!currentJWT && oldSession.userId) {
        return await options.upgradeJWT();
    }
    else {
        return await options.refreshJWT();
    }
}
exports.default = default_1;
